import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

import ImageLoader from './ImageLoader';
import ModalDeleteImage from './ModalDeleteImage';

class ImageEdit extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['user', 'group']),
    fieldName: PropTypes.oneOf(['profile_icon', 'group_icon']),
  };

  static defaultProps = {
  };

  state = {
    file: null,
  };

  imageUrl = () => {
    return get(this.props, 'type') === 'user' ? 'resource.profile_icon.thumb.url' : 'resource.group_icon.thumb.url'
  }

  render = () => {
    return (
      <div className='ImageEdit'>
        <div className='ImageEdit__left'>
          <div className='ImageBorder'>
            <ImageLoader
              url={this.state.file ? URL.createObjectURL(this.state.file) : get(this.props, this.imageUrl())}
            />
          </div>

          <label className='ImageEdit__left__label'>
            <input
              type='file'
              name={`${get(this.props, 'type')}[${get(this.props, 'fieldName')}]`}
              accept='image/png, image/jpeg'
              onChange={(e) => {
                this.setState({
                  file: get(e, 'target.files[0]'),
                })
              }}
            />
            <span>Change photo</span>
          </label>
        </div>

        <ModalDeleteImage
          klassName='ImageEdit__remove'
          id={get(this.props, 'resource.id')}
          resourceType={get(this.props, 'type')}
          imageType='icon'
        />
      </div>
    );
  }
}

export default ImageEdit;
